import React from 'react'
import {Routes, Route, Navigate} from 'react-router'
import {useAuth} from 'react-oidc-context'
import {
  Dashboard,
  FinancierPagesWrapper,
  Calls,
  Deals,
  Settings,
  Pipeline,
  CandidatesDetailPage,
  CallsDetailsPage,
  FinancierCompanyDetails,
  FinancierServiceProviders,
  FinancierProfile,
  LazyComponent,
} from './LazyRoutes'

const SuperUserRoutes = () => {
  const auth = useAuth()
  return (
    <Routes>
      <Route
        path='/*'
        element={
          <LazyComponent>
            <FinancierPagesWrapper />
          </LazyComponent>
        }
      >
        <Route
          index
          path='pipeline'
          element={
            <LazyComponent>
              <Pipeline />
            </LazyComponent>
          }
        />
        <Route
          path='pipeline/:id'
          element={
            <LazyComponent>
              <FinancierCompanyDetails />
            </LazyComponent>
          }
        />
        <Route
          path='service-providers'
          element={
            <LazyComponent>
              <FinancierServiceProviders />
            </LazyComponent>
          }
        />
        <Route
          path='calls'
          element={
            <LazyComponent>
              <Calls />
            </LazyComponent>
          }
        />
        <Route
          path='dashboard'
          element={
            <LazyComponent>
              <Dashboard />
            </LazyComponent>
          }
        />
        <Route
          path='calls/:callId'
          element={
            <LazyComponent>
              <CallsDetailsPage />
            </LazyComponent>
          }
        />
        <Route
          path='calls/:callId/applications/:stage/:applicationIndex'
          element={
            <LazyComponent>
              <CandidatesDetailPage />
            </LazyComponent>
          }
        />
        <Route
          path='deals'
          element={
            <LazyComponent>
              <Deals />
            </LazyComponent>
          }
        />
        <Route
          path='settings'
          element={
            <LazyComponent>
              <Settings />
            </LazyComponent>
          }
        />
        <Route
          path='profile'
          element={
            <LazyComponent>
              <FinancierProfile />
            </LazyComponent>
          }
        />
      </Route>
      <Route path='/' element={<Navigate to={`/pipeline`} />} />
      <Route path='auth/*' element={<Navigate to={`/pipeline`} />} />
    </Routes>
  )
}

export default SuperUserRoutes
